import axios from 'axios'

const axiosConfig = {
    // baseURL: 'http://localhost:5000/api'
    baseURL: 'https://petto-test.herokuapp.com/api'
};
const baseUrl = axios.create(axiosConfig)

export default baseUrl